import { render, staticRenderFns } from "./NoDataAvailablePlaceholder.vue?vue&type=template&id=0b631024&"
import script from "./NoDataAvailablePlaceholder.vue?vue&type=script&lang=ts&"
export * from "./NoDataAvailablePlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./NoDataAvailablePlaceholder.vue?vue&type=style&index=0&id=0b631024&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports